import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { backend_url } from "./clientUrl";
import { FaClipboard, FaCheck } from "react-icons/fa"; // Import icons
import Navbar from "./Navbar";

function History() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);
  const [copySuccessId, setCopySuccessId] = useState(null); // Track copied order ID
  const token = localStorage.getItem("accessToken");

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await fetch(`${backend_url}/auth/history`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error("Failed to fetch order history");

        const data = await response.json();
        setOrders(data.orders || []);
      } catch (error) {
        console.error(error);
        setError(error.message);
        navigate("/login");
      }
    };

    fetchOrders();
  }, [navigate, token]);

  const handleCopy = (trackingId) => {
    navigator.clipboard.writeText(trackingId).then(() => {
      setCopySuccessId(trackingId);
      setTimeout(() => setCopySuccessId(null), 2000); // Reset icon after 2 seconds
    });
  };

  // Group orders by date
  const groupedOrders = orders.reduce((acc, order) => {
    const date = new Date(order.date).toLocaleDateString();
    acc[date] = acc[date] ? [...acc[date], order] : [order];
    return acc;
  }, {});

  return (
    <div>
    <div className="navbar">
    <Navbar bgColor="bg-gray-800"/>
    </div>
    <div className="container mx-auto p-6 my-32">
      <h1 className="text-3xl font-bold text-center mb-6">My orders</h1>

      {error && <div className="text-red-500 text-center">{error}</div>}

      {Object.keys(groupedOrders).length === 0 ? (
        <p className="text-center mt-6 text-gray-500">No orders booked by you.</p>
      ) : (
        Object.entries(groupedOrders).map(([date, orders]) => (
          <div key={date} className="mb-8 border border-gray-300 shadow-lg rounded-lg p-4">
            <h2 className="text-lg font-semibold text-gray-800 mb-4 border-b border-gray-300 pb-2">
              {date}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {orders.map((order) => (
                <div key={order._id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow">
                  <img
                    src={order.product.img}
                    alt={order.product.name}
                    className="h-40 w-full object-cover"
                  />
                  <div className="p-4">
                    <h3 className="text-lg font-bold text-gray-700">{order.product.name}</h3>
                    <div className="flex items-center mt-1">
                      <p className="text-gray-500 mr-2">Order ID: {order.tracking_id}</p>
                      <button
                        onClick={() => handleCopy(order.tracking_id)}
                        className="text-gray-500 hover:text-black"
                      >
                        {copySuccessId === order.tracking_id ? (
                          <FaCheck className="text-green-500" />
                        ) : (
                          <FaClipboard />
                        )}
                      </button>
                    </div>
                    <p className="text-gray-500 mt-1">Price: ${order.amount}</p>
                    <p className="text-gray-500 mt-1">Status: {order.status}</p>
                    <button
                      onClick={() => window.open(`https://shiprocket.co/tracking/order/${order.tracking_id}?company_id=5056266`, "_blank")}
                      className="mt-4 w-full bg-black text-white py-2 rounded-lg hover:bg-gray-800 transition-colors"
                    >
                      Track Order
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
              <div className="btn w-full flex items-center justify-center">
                <Link to='catalogue' className="p-3 rounded-lg cursor-pointer bg-black text-white w-60 my-8 ">Continue Shopping</Link>
              </div>
    </div>
    </div>
  );
}

export default History;
